import FullScreenLoader from "../BON Frontend/Booking-Form/Common/FullScreenLoader";
import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";

import { AgentHeader } from "./Commun/AgentHeader";
import AgentSidebar from "./Commun/AgentSidebar";
import { agentroomlist } from "../Services/Service";
import swal from "sweetalert";



export const AgentRooms = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [propertyDetails, setPropertyDetails] = useState(null);
    const [roomList, setRoomList] = useState([]);
    const [showFullDescription, setShowFullDescription] = useState(false);
    const [expandedDescriptions, setExpandedDescriptions] = useState({});
    const [selectedMeals, setSelectedMeals] = useState({});
    const [mealCounts, setMealCounts] = useState({});
    const [showPopup, setShowPopup] = useState(false);
    const [selectedRooms, setSelectedRooms] = useState([]);

    //  Select room 
    const handleSelect = (roomId, rateCode = "", mealCode = "", idx) => {

        if (!rateCode || !mealCode) {
            swal({
                // title: "Oops!",
                text: "Please select Rate Code and Meal Plan first!",
                icon: "warning",
                button: "OK"
            });
            return;
        }


        let maxRoomBook = parseInt(localStorage.getItem("MaxRoomBook"));
        if (!maxRoomBook || maxRoomBook < 1) maxRoomBook = 1;

        const room = roomList.find(r => r.RoomID === roomId);
        let ratePlans = [];
        try {
            ratePlans = JSON.parse(room.RatePlan);
        } catch (err) { ratePlans = []; }

        const selectedRateObj = ratePlans.find(rp => rp.Code === rateCode) || {};
        const selectedMealObj = selectedRateObj?.MealPlan?.find(mp => mp.Code === mealCode) || {};

        const baseRate =
            selectedMealObj?._RCM?.[0]?.BaseRate ||
            selectedRateObj?._RCM?.[0]?.BaseRate ||
            0;
        const extraAdultRate =
            selectedMealObj?._RCM?.[0]?.ExtraAdultRate ||
            selectedRateObj?._RCM?.[0]?.ExtraAdultRate ||
            0;
        const extraChildRate =
            selectedMealObj?._RCM?.[0]?.ExtraChildRate ||
            selectedRateObj?._RCM?.[0]?.ExtraChildRate ||
            0;

        // Update selectedMeals
        setSelectedMeals(prev => ({
            ...prev,
            [roomId]: {
                ratePlan: rateCode,
                mealPlan: mealCode,
                rateValue: baseRate
            }
        }));

        // Update selectedRooms (without opening modal)
        setSelectedRooms(prev => [
            ...prev.filter(r => r.RoomID !== roomId),
            {
                ...room,
                selectedMealPlan: {
                    RatePlan: selectedRateObj.Name || "",
                    MealPlan: selectedMealObj.Name || "",
                    BaseRate: baseRate,
                    ExtraAdultRate: extraAdultRate,
                    ExtraChildRate: extraChildRate,
                    Rate: baseRate,
                },
                adults: 1,
                children: 0,
                quantity: 1,
                MaxRoomBook: maxRoomBook
            }
        ]);

        // Initialize mealCounts
        const key = `${roomId}-${idx}`;
        setMealCounts(prev => ({ ...prev, [key]: 1 }));

    };


    // --- Increment/Decrement ---
    const handleIncrement = (roomId, idx) => {
        const key = `${roomId}-${idx}`;
        setMealCounts(prev => {
            const current = prev[key] || 1;
            const room = selectedRooms.find(r => r.RoomID === roomId);
            let maxRoomBook = room?.MaxRoomBook || parseInt(localStorage.getItem("MaxRoomBook"));
            if (!maxRoomBook || maxRoomBook < 1) maxRoomBook = 1;

            if (current >= maxRoomBook) return prev;
            const updatedCount = current + 1;

            setSelectedRooms(prevRooms =>
                prevRooms.map(r => r.RoomID === roomId ? { ...r, quantity: updatedCount } : r)
            );

            return { ...prev, [key]: updatedCount };
        });
    };



    const handleDecrement = (roomId, idx) => {
        const key = `${roomId}-${idx}`;
        const current = mealCounts[key] || 1;

        if (current <= 1) {
            setMealCounts((prev) => {
                const updated = { ...prev };
                delete updated[key];
                return updated;
            });

            setSelectedMeals((prev) => {
                const updated = { ...prev };
                if (updated[roomId]) delete updated[roomId];
                return updated;
            });

            setSelectedRooms((prev) => prev.filter((r) => r.RoomID !== roomId));
        } else {
            const updatedCount = current - 1;

            setSelectedRooms((prevRooms) =>
                prevRooms.map((r) =>
                    r.RoomID === roomId ? { ...r, quantity: updatedCount } : r
                )
            );

            setMealCounts((prev) => ({ ...prev, [key]: updatedCount }));
        }
    };



    const updateRoomOccupancy = (roomId, field, action) => {
        setSelectedRooms((prevRooms) =>
            prevRooms.map((room) => {
                if (room.RoomID !== roomId) return room;

                let newAdults = room.adults;
                let newChildren = room.children;

                if (field === "adults") {
                    newAdults =
                        action === "increment"
                            ? newAdults + 1
                            : Math.max(1, newAdults - 1);
                } else if (field === "children") {
                    newChildren =
                        action === "increment"
                            ? newChildren + 1
                            : Math.max(0, newChildren - 1);
                }

                const base = room.selectedMealPlan.BaseRate || 0;
                const extraAdultRate = room.selectedMealPlan.ExtraAdultRate || 0;
                const extraChildRate = room.selectedMealPlan.ExtraChildRate || 0;

                const totalRate =
                    base + (newAdults - 1) * extraAdultRate + newChildren * extraChildRate;

                return {
                    ...room,
                    adults: newAdults,
                    children: newChildren,
                    selectedMealPlan: {
                        ...room.selectedMealPlan,
                        Rate: totalRate,
                    },
                };
            })
        );
    };


    useEffect(() => {
        const FetchRooms = async () => {
            setLoading(true);
            try {
                const propertyID = localStorage.getItem("selectedPropertyID");
                if (!propertyID) {
                    console.log("No property ID found in localStorage");
                    return;
                }
                //    console.log("property id",propertyID)

                const result = await agentroomlist(parseInt(propertyID));
                // console.log("API Result:", result);

                setPropertyDetails(result?.PropertyDetails?.[0] || null);
                setRoomList(result?.RoomsDetails || []);
            }
            catch (error) {
                console.log("error fetching rooms", error);
            } finally {
                setLoading(false);
            }
        }
        FetchRooms();
    }, []);


    const toggleDescription = (roomId) => {
        setExpandedDescriptions((prev) => ({
            ...prev,
            [roomId]: !prev[roomId],
        }));
    };


    const checkInDate = localStorage.getItem("checkInDate");
    const checkOutDate = localStorage.getItem("checkOutDate");

    const handleContinue = () => {

        // Save selectedRooms to localStorage
        localStorage.setItem("selectedRooms", JSON.stringify(selectedRooms));

        console.log("Saved to localStorage:", selectedRooms);

        navigate("/Agent/roomselected");
    };

    // useEffect(() => {
    //     console.log("room details", localStorage.getItem("selectedRooms"));
    // }, [])

    return (
        <>
            {loading && (
                <FullScreenLoader />
            )}

            <div className="wrapper">
                <AgentSidebar />
                <div className="main-panel">
                    <AgentHeader />
                    <div className="container">
                        <div className="page-inner">
                            {/* Property Section */}
                            <div className="text-end mb-3">
                                <Link to="/Agent/Booking" className="btn btn-black btn-sm"><i className="fas fa-arrow-left me-2"></i>Back to Agent Booking</Link>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="card p-3">
                                        <div className="d-flex flex-column  flex-md-row align-items-start">
                                            {/* Image */}
                                            <div className="w-100 w-md-auto mb-3 mb-md-0" style={{ maxWidth: "21rem" }}>
                                                <img
                                                    src={propertyDetails?.PropertyLogo || "N/A"}
                                                    alt="Property logo"
                                                    className="img-fluid rounded"
                                                    style={{
                                                        width: "100%",
                                                        height: "auto",
                                                        maxHeight: "9rem",
                                                        objectFit: "cover",
                                                    }}
                                                />
                                            </div>

                                            {/* Text */}
                                            <div className="ms-md-4 d-flex flex-column justify-content-between w-100">
                                                <div>
                                                    <h5 className="fw-bold">{propertyDetails?.PropertyName}</h5>
                                                    <p className="mb-2">
                                                        <i className="fas fa-map-marker-alt me-2"></i>
                                                        {propertyDetails?.Address}
                                                    </p>

                                                    <p className="mb-2 text-muted">
                                                        {propertyDetails?.Description
                                                            ? showFullDescription
                                                                ? propertyDetails.Description
                                                                : `${propertyDetails.Description.slice(0, 100)}...`
                                                            : "No description available."}

                                                        {propertyDetails?.Description &&
                                                            propertyDetails.Description.length > 100 && (
                                                                <span
                                                                    onClick={() => setShowFullDescription(!showFullDescription)}
                                                                    style={{
                                                                        color: "#007bff",
                                                                        cursor: "pointer",
                                                                        marginLeft: "8px",
                                                                        fontWeight: "500",
                                                                    }}
                                                                >
                                                                    {showFullDescription ? "Read Less" : "Read More"}
                                                                </span>
                                                            )}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Rooms List Section */}
                            <div className="row">
                                {/* {roomList.map((room, i) => ( */}
                                {roomList.map((room, i) => {
                                    let ratePlans = [];
                                    try {
                                        if (room.RatePlan) ratePlans = JSON.parse(room.RatePlan);
                                    } catch (error) {
                                        console.error("Invalid RatePlan JSON", error);
                                    }

                                    const selectedRate = selectedMeals[room.RoomID]?.ratePlan || "";
                                    const selectedMeal = selectedMeals[room.RoomID]?.mealPlan || "";
                                    return (
                                        <div className="col-12" key={i}>
                                            <div className="card shadow-sm">
                                                <div className="row g-0 flex-column p-3 flex-md-row">
                                                    <div className="col-md-4 ">
                                                        <img
                                                            // src={room.RoomPhoto || "N/A"}
                                                            src="/assets/img/Bedroom image 2.jpg"
                                                            alt="Room"
                                                            className="img-fluid rounded-start w-100"
                                                            style={{ maxHeight: "200px", objectFit: "cover" }}
                                                        />
                                                    </div>

                                                    <div className="col-md-8 ">
                                                        <h5 className="fw-bold">{room.RoomName}</h5>

                                                        <div className="text-muted">
                                                            {room.Description ? (
                                                                <>
                                                                    {expandedDescriptions[room.RoomID]
                                                                        ? room.Description
                                                                        : `${room.Description.slice(0, 100)}...`}

                                                                    {room.Description.length > 100 && (
                                                                        <span
                                                                            onClick={() => toggleDescription(room.RoomID)}
                                                                            style={{
                                                                                color: "#007bff",
                                                                                cursor: "pointer",
                                                                                marginLeft: "8px",
                                                                                fontWeight: "500",
                                                                            }}
                                                                        >
                                                                            {expandedDescriptions[room.RoomID] ? "Read Less" : "Read More"}
                                                                        </span>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                "No description available."
                                                            )}
                                                        </div>

                                                        <strong>Meal Plans:</strong>
                                                        {/* Rate & Meal Plan */}
                                                        <div className="row mt-2">
                                                            <div className="col-md-3">
                                                                <select
                                                                    className="form-select form-control"
                                                                    value={selectedRate}
                                                                    onChange={(e) => {
                                                                        const rate = ratePlans.find(rp => rp.Code === e.target.value);
                                                                        setSelectedMeals(prev => ({
                                                                            ...prev,
                                                                            [room.RoomID]: {
                                                                                ratePlan: e.target.value,
                                                                                mealPlan: "",
                                                                                rateValue: rate?._RCM?.[0]?.BaseRate || 0
                                                                            }
                                                                        }));
                                                                    }}
                                                                >
                                                                    <option>select rate code</option>
                                                                    {ratePlans.map((rp, idx) => (
                                                                        <option key={idx} value={rp.Code}>{rp.Name}</option>
                                                                    ))}
                                                                </select>
                                                            </div>

                                                            <div className="col-md-3">
                                                                <select
                                                                    className="form-select form-control"
                                                                    value={selectedMeal}
                                                                    onChange={e => {
                                                                        const rate = ratePlans.find(rp => rp.Code === selectedRate);
                                                                        const meal = rate?.MealPlan?.find(mp => mp.Code === e.target.value);
                                                                        setSelectedMeals(prev => ({
                                                                            ...prev,
                                                                            [room.RoomID]: {
                                                                                ...prev[room.RoomID],
                                                                                mealPlan: e.target.value,
                                                                                rateValue: meal?._RCM?.[0]?.BaseRate || rate?._RCM?.[0]?.BaseRate || 0
                                                                            }
                                                                        }));
                                                                    }}
                                                                >
                                                                    <option>select meal plan</option>
                                                                    {ratePlans.length > 0 && ratePlans.find(rp => rp.Code === selectedRate)?.MealPlan?.map((mp, idx) =>
                                                                        <option key={idx} value={mp.Code}>{mp.Name}</option>
                                                                    )}
                                                                </select>
                                                            </div>

                                                            <div className="col-md-4">
                                                                <div className="text-center fw-bold" style={{ padding: "10px" }}>₹ {selectedMeals[room.RoomID]?.rateValue || 0}</div>
                                                            </div>

                                                            <div className="col-md-2">
                                                                {/* Select / Increment-Decrement Buttons */}
                                                                {selectedRooms.find(r => r.RoomID === room.RoomID) ? (
                                                                    <div className="hstack gap-2 mt-1">
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-outline-secondary btn-sm px-2 py-1"
                                                                            onClick={() => handleDecrement(room.RoomID, room.RoomID)}
                                                                        >
                                                                            <i className="fas fa-minus"></i>
                                                                        </button>
                                                                        <span className="fw-semibold">
                                                                            {mealCounts[`${room.RoomID}-${room.RoomID}`] || 1}
                                                                        </span>
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-outline-secondary btn-sm px-2 py-1"
                                                                            onClick={() => handleIncrement(room.RoomID, room.RoomID)}
                                                                        >
                                                                            <i className="fas fa-plus"></i>
                                                                        </button>
                                                                    </div>
                                                                ) : (
                                                                    <button
                                                                        className="btn btn-sm btn-black mt-1"
                                                                        onClick={() => handleSelect(room.RoomID, selectedRate, selectedMeal, room.RoomID)}
                                                                    >
                                                                        Select
                                                                    </button>
                                                                )}

                                                            </div>
                                                        </div>


                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>

                            {selectedRooms.length > 0 && (
                                <div
                                    className="bg-gray1 text-end p-3"
                                    style={{
                                        position: "fixed",
                                        bottom: 0,
                                        left: 0,
                                        width: "100%",
                                        zIndex: 999,
                                        boxShadow: "0 -2px 6px rgba(0,0,0,0.1)",
                                    }}
                                >
                                    <button className="btn btn-primary" onClick={() => setShowPopup(true)}>
                                        Continue ({selectedRooms.length})
                                    </button>
                                </div>
                            )}

                        </div>
                    </div>


                    {showPopup && (
                        <div
                            className="modal d-block"
                            tabIndex="-1"
                            style={{
                                backgroundColor: "rgba(0, 0, 0, 0.5)",
                                position: "fixed",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                zIndex: 1050,
                                padding: "18px",
                            }}
                        >
                            <div
                                className="modal-dialog"
                                style={{
                                    maxWidth: "500px",
                                    width: "100%",
                                }}
                            >
                                <div
                                    className="modal-content"
                                    style={{
                                        borderRadius: "10px",
                                        left: "-8px",
                                        overflow: "hidden",
                                    }}
                                >
                                    <div className="modal-header">
                                        <h5 className="modal-title">Selected Rooms</h5>
                                    </div>

                                    <div className="modal-body  p-3">
                                        {/* Date section */}
                                        <div className="d-flex justify-content-between mb-3">
                                            <div className="fw-bold text-dark">From : <span className="fw-normal">{checkInDate}</span></div>
                                            <div className="fw-bold text-dark">To : <span className="fw-normal">{checkOutDate}</span></div>
                                        </div>

                                        {/* Render rooms based on quantity */}
                                        {selectedRooms.map((room) =>
                                            Array.from({ length: room.quantity }).map((_, idx) => (
                                                <div key={`${room.RoomID}-${idx}`}
                                                    className="p-3 rounded-3 mt-3 position-relative"
                                                    style={{
                                                        backgroundColor: "rgb(245 245 245)",
                                                    }}
                                                >
                                                    <div className="d-flex justify-content-between mb-2">
                                                        <div className="fw-bold text-dark fs-6">{room.RoomName}</div>
                                                        <div className="fw-bold">Plan ( <span className="fw-bold text-danger">{room.selectedMealPlan.RatePlan}</span> )</div>
                                                    </div>


                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="d-flex gap-5">
                                                                <div>
                                                                    <label className="fw-bold d-block mb-2">Adults</label>
                                                                    <div className="hstack gap-2">
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-outline-secondary btn-sm px-2 py-1"
                                                                            onClick={() => updateRoomOccupancy(room.RoomID, 'adults', 'decrement')}
                                                                        >
                                                                            <i className="fas fa-minus"></i>
                                                                        </button>
                                                                        <span className="fw-semibold">{room.adults}</span>
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-outline-secondary btn-sm px-2 py-1"
                                                                            onClick={() => updateRoomOccupancy(room.RoomID, 'adults', 'increment')}
                                                                        >
                                                                            <i className="fas fa-plus"></i>
                                                                        </button>
                                                                    </div>
                                                                </div>

                                                                <div>
                                                                    <label className="fw-semibold d-block mb-2">Child</label>
                                                                    <div className="hstack gap-2">
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-outline-secondary btn-sm px-2 py-1"
                                                                            onClick={() => updateRoomOccupancy(room.RoomID, 'children', 'decrement')}
                                                                        >
                                                                            <i className="fas fa-minus"></i>
                                                                        </button>
                                                                        <span className="fw-semibold">{room.children}</span>
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-outline-secondary btn-sm px-2 py-1"
                                                                            onClick={() => updateRoomOccupancy(room.RoomID, 'children', 'increment')}
                                                                        >
                                                                            <i className="fas fa-plus"></i>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Rate at bottom-right */}
                                                    <div
                                                        className="fw-bold fs-5 position-absolute"
                                                        style={{ bottom: "10px", right: "15px" }}
                                                    >
                                                        ₹ {room.selectedMealPlan?.Rate || "N/A"}
                                                    </div>
                                                </div>
                                            ))
                                        )}

                                    </div>

                                    {/* Modal Action */}
                                    <div className="modal-action">
                                        <button className="btn btn-danger me-2" onClick={() => setShowPopup(false)}>
                                            Cancel
                                        </button>
                                        <button className="btn btn-primary" onClick={handleContinue}>Continue</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}


                </div>

            </div>
        </>
    )
}
